import { EvidentlyServiceException as __BaseException } from "./EvidentlyServiceException";
export class AccessDeniedException extends __BaseException {
    constructor(opts) {
        super({
            name: "AccessDeniedException",
            $fault: "client",
            ...opts,
        });
        this.name = "AccessDeniedException";
        this.$fault = "client";
        Object.setPrototypeOf(this, AccessDeniedException.prototype);
    }
}
export var VariableValue;
(function (VariableValue) {
    VariableValue.visit = (value, visitor) => {
        if (value.boolValue !== undefined)
            return visitor.boolValue(value.boolValue);
        if (value.stringValue !== undefined)
            return visitor.stringValue(value.stringValue);
        if (value.longValue !== undefined)
            return visitor.longValue(value.longValue);
        if (value.doubleValue !== undefined)
            return visitor.doubleValue(value.doubleValue);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(VariableValue || (VariableValue = {}));
export class ResourceNotFoundException extends __BaseException {
    constructor(opts) {
        super({
            name: "ResourceNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "ResourceNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ResourceNotFoundException.prototype);
        this.resourceId = opts.resourceId;
        this.resourceType = opts.resourceType;
    }
}
export class ThrottlingException extends __BaseException {
    constructor(opts) {
        super({
            name: "ThrottlingException",
            $fault: "client",
            ...opts,
        });
        this.name = "ThrottlingException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ThrottlingException.prototype);
        this.serviceCode = opts.serviceCode;
        this.quotaCode = opts.quotaCode;
    }
}
export var ValidationExceptionReason;
(function (ValidationExceptionReason) {
    ValidationExceptionReason["CANNOT_PARSE"] = "cannotParse";
    ValidationExceptionReason["FIELD_VALIDATION_FAILED"] = "fieldValidationFailed";
    ValidationExceptionReason["OTHER"] = "other";
    ValidationExceptionReason["UNKNOWN_OPERATION"] = "unknownOperation";
})(ValidationExceptionReason || (ValidationExceptionReason = {}));
export class ValidationException extends __BaseException {
    constructor(opts) {
        super({
            name: "ValidationException",
            $fault: "client",
            ...opts,
        });
        this.name = "ValidationException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ValidationException.prototype);
        this.reason = opts.reason;
        this.fieldList = opts.fieldList;
    }
}
export var ChangeDirectionEnum;
(function (ChangeDirectionEnum) {
    ChangeDirectionEnum["DECREASE"] = "DECREASE";
    ChangeDirectionEnum["INCREASE"] = "INCREASE";
})(ChangeDirectionEnum || (ChangeDirectionEnum = {}));
export class ConflictException extends __BaseException {
    constructor(opts) {
        super({
            name: "ConflictException",
            $fault: "client",
            ...opts,
        });
        this.name = "ConflictException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ConflictException.prototype);
        this.resourceId = opts.resourceId;
        this.resourceType = opts.resourceType;
    }
}
export var ExperimentStatus;
(function (ExperimentStatus) {
    ExperimentStatus["CANCELLED"] = "CANCELLED";
    ExperimentStatus["COMPLETED"] = "COMPLETED";
    ExperimentStatus["CREATED"] = "CREATED";
    ExperimentStatus["RUNNING"] = "RUNNING";
    ExperimentStatus["UPDATING"] = "UPDATING";
})(ExperimentStatus || (ExperimentStatus = {}));
export var ExperimentType;
(function (ExperimentType) {
    ExperimentType["ONLINE_AB_EXPERIMENT"] = "aws.evidently.onlineab";
})(ExperimentType || (ExperimentType = {}));
export class ServiceQuotaExceededException extends __BaseException {
    constructor(opts) {
        super({
            name: "ServiceQuotaExceededException",
            $fault: "client",
            ...opts,
        });
        this.name = "ServiceQuotaExceededException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ServiceQuotaExceededException.prototype);
        this.resourceId = opts.resourceId;
        this.resourceType = opts.resourceType;
        this.serviceCode = opts.serviceCode;
        this.quotaCode = opts.quotaCode;
    }
}
export var FeatureEvaluationStrategy;
(function (FeatureEvaluationStrategy) {
    FeatureEvaluationStrategy["ALL_RULES"] = "ALL_RULES";
    FeatureEvaluationStrategy["DEFAULT_VARIATION"] = "DEFAULT_VARIATION";
})(FeatureEvaluationStrategy || (FeatureEvaluationStrategy = {}));
export var FeatureStatus;
(function (FeatureStatus) {
    FeatureStatus["AVAILABLE"] = "AVAILABLE";
    FeatureStatus["UPDATING"] = "UPDATING";
})(FeatureStatus || (FeatureStatus = {}));
export var VariationValueType;
(function (VariationValueType) {
    VariationValueType["BOOLEAN"] = "BOOLEAN";
    VariationValueType["DOUBLE"] = "DOUBLE";
    VariationValueType["LONG"] = "LONG";
    VariationValueType["STRING"] = "STRING";
})(VariationValueType || (VariationValueType = {}));
export var LaunchStatus;
(function (LaunchStatus) {
    LaunchStatus["CANCELLED"] = "CANCELLED";
    LaunchStatus["COMPLETED"] = "COMPLETED";
    LaunchStatus["CREATED"] = "CREATED";
    LaunchStatus["RUNNING"] = "RUNNING";
    LaunchStatus["UPDATING"] = "UPDATING";
})(LaunchStatus || (LaunchStatus = {}));
export var LaunchType;
(function (LaunchType) {
    LaunchType["SCHEDULED_SPLITS_LAUNCH"] = "aws.evidently.splits";
})(LaunchType || (LaunchType = {}));
export var ProjectStatus;
(function (ProjectStatus) {
    ProjectStatus["AVAILABLE"] = "AVAILABLE";
    ProjectStatus["UPDATING"] = "UPDATING";
})(ProjectStatus || (ProjectStatus = {}));
export class InternalServerException extends __BaseException {
    constructor(opts) {
        super({
            name: "InternalServerException",
            $fault: "server",
            ...opts,
        });
        this.name = "InternalServerException";
        this.$fault = "server";
        Object.setPrototypeOf(this, InternalServerException.prototype);
    }
}
export class ServiceUnavailableException extends __BaseException {
    constructor(opts) {
        super({
            name: "ServiceUnavailableException",
            $fault: "server",
            ...opts,
        });
        this.name = "ServiceUnavailableException";
        this.$fault = "server";
        Object.setPrototypeOf(this, ServiceUnavailableException.prototype);
    }
}
export var EventType;
(function (EventType) {
    EventType["CUSTOM"] = "aws.evidently.custom";
    EventType["EVALUATION"] = "aws.evidently.evaluation";
})(EventType || (EventType = {}));
export var ExperimentBaseStat;
(function (ExperimentBaseStat) {
    ExperimentBaseStat["MEAN"] = "Mean";
})(ExperimentBaseStat || (ExperimentBaseStat = {}));
export var ExperimentReportName;
(function (ExperimentReportName) {
    ExperimentReportName["BAYESIAN_INFERENCE"] = "BayesianInference";
})(ExperimentReportName || (ExperimentReportName = {}));
export var ExperimentResultRequestType;
(function (ExperimentResultRequestType) {
    ExperimentResultRequestType["BASE_STAT"] = "BaseStat";
    ExperimentResultRequestType["CONFIDENCE_INTERVAL"] = "ConfidenceInterval";
    ExperimentResultRequestType["P_VALUE"] = "PValue";
    ExperimentResultRequestType["TREATMENT_EFFECT"] = "TreatmentEffect";
})(ExperimentResultRequestType || (ExperimentResultRequestType = {}));
export var ExperimentResultResponseType;
(function (ExperimentResultResponseType) {
    ExperimentResultResponseType["CONFIDENCE_INTERVAL_LOWERBOUND"] = "ConfidenceIntervalLowerBound";
    ExperimentResultResponseType["CONFIDENCE_INTERVAL_UPPERBOUND"] = "ConfidenceIntervalUpperBound";
    ExperimentResultResponseType["MEAN"] = "Mean";
    ExperimentResultResponseType["P_VALUE"] = "PValue";
    ExperimentResultResponseType["TREATMENT_EFFECT"] = "TreatmentEffect";
})(ExperimentResultResponseType || (ExperimentResultResponseType = {}));
export var ExperimentStopDesiredState;
(function (ExperimentStopDesiredState) {
    ExperimentStopDesiredState["CANCELLED"] = "CANCELLED";
    ExperimentStopDesiredState["COMPLETED"] = "COMPLETED";
})(ExperimentStopDesiredState || (ExperimentStopDesiredState = {}));
export var LaunchStopDesiredState;
(function (LaunchStopDesiredState) {
    LaunchStopDesiredState["CANCELLED"] = "CANCELLED";
    LaunchStopDesiredState["COMPLETED"] = "COMPLETED";
})(LaunchStopDesiredState || (LaunchStopDesiredState = {}));
export var SegmentReferenceResourceType;
(function (SegmentReferenceResourceType) {
    SegmentReferenceResourceType["EXPERIMENT"] = "EXPERIMENT";
    SegmentReferenceResourceType["LAUNCH"] = "LAUNCH";
})(SegmentReferenceResourceType || (SegmentReferenceResourceType = {}));
export const EvaluationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BatchEvaluateFeatureRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const VariableValueFilterSensitiveLog = (obj) => {
    if (obj.boolValue !== undefined)
        return { boolValue: obj.boolValue };
    if (obj.stringValue !== undefined)
        return { stringValue: obj.stringValue };
    if (obj.longValue !== undefined)
        return { longValue: obj.longValue };
    if (obj.doubleValue !== undefined)
        return { doubleValue: obj.doubleValue };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: "UNKNOWN" };
};
export const EvaluationResultFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.value && { value: VariableValueFilterSensitiveLog(obj.value) }),
});
export const BatchEvaluateFeatureResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.results && { results: obj.results.map((item) => EvaluationResultFilterSensitiveLog(item)) }),
});
export const ValidationExceptionFieldFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CloudWatchLogsDestinationFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CloudWatchLogsDestinationConfigFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MetricDefinitionConfigFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MetricGoalConfigFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const OnlineAbConfigFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TreatmentConfigFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateExperimentRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ExperimentExecutionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MetricDefinitionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MetricGoalFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const OnlineAbDefinitionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ExperimentScheduleFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TreatmentFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ExperimentFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateExperimentResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const VariationConfigFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.value && { value: VariableValueFilterSensitiveLog(obj.value) }),
});
export const CreateFeatureRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.variations && { variations: obj.variations.map((item) => VariationConfigFilterSensitiveLog(item)) }),
});
export const EvaluationRuleFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const VariationFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.value && { value: VariableValueFilterSensitiveLog(obj.value) }),
});
export const FeatureFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.variations && { variations: obj.variations.map((item) => VariationFilterSensitiveLog(item)) }),
});
export const CreateFeatureResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.feature && { feature: FeatureFilterSensitiveLog(obj.feature) }),
});
export const LaunchGroupConfigFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MetricMonitorConfigFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SegmentOverrideFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ScheduledSplitConfigFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ScheduledSplitsLaunchConfigFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateLaunchRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const LaunchExecutionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const LaunchGroupFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MetricMonitorFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ScheduledSplitFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ScheduledSplitsLaunchDefinitionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const LaunchFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateLaunchResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ProjectAppConfigResourceConfigFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const S3DestinationConfigFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ProjectDataDeliveryConfigFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateProjectRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ProjectAppConfigResourceFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const S3DestinationFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ProjectDataDeliveryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ProjectFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateProjectResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateSegmentRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SegmentFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateSegmentResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteExperimentRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteExperimentResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteFeatureRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteFeatureResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteLaunchRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteLaunchResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteProjectRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteProjectResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteSegmentRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteSegmentResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EvaluateFeatureRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EvaluateFeatureResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.value && { value: VariableValueFilterSensitiveLog(obj.value) }),
});
export const EventFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListTagsForResourceRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListTagsForResourceResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetExperimentRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetExperimentResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetExperimentResultsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ExperimentReportFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ExperimentResultsDataFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetExperimentResultsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListExperimentsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListExperimentsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const StartExperimentRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const StartExperimentResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const StopExperimentRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const StopExperimentResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateExperimentRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateExperimentResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetFeatureRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetFeatureResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.feature && { feature: FeatureFilterSensitiveLog(obj.feature) }),
});
export const ListFeaturesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const FeatureSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListFeaturesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateFeatureRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.addOrUpdateVariations && {
        addOrUpdateVariations: obj.addOrUpdateVariations.map((item) => VariationConfigFilterSensitiveLog(item)),
    }),
});
export const UpdateFeatureResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.feature && { feature: FeatureFilterSensitiveLog(obj.feature) }),
});
export const GetProjectRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetProjectResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetLaunchRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetLaunchResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListLaunchesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListLaunchesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const StartLaunchRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const StartLaunchResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const StopLaunchRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const StopLaunchResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateLaunchRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateLaunchResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListProjectsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ProjectSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListProjectsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PutProjectEventsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PutProjectEventsResultEntryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PutProjectEventsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateProjectRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateProjectResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateProjectDataDeliveryRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateProjectDataDeliveryResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetSegmentRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetSegmentResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListSegmentReferencesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RefResourceFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListSegmentReferencesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListSegmentsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListSegmentsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TagResourceRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TagResourceResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TestSegmentPatternRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TestSegmentPatternResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UntagResourceRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UntagResourceResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
